import {createSimpleAction, createTypeAction} from "../utils/actionUtils";
export const PUSH_HISTORY = 'PUSH_HISTORY'

export const pushHistory = createSimpleAction(PUSH_HISTORY, 'history')

export const CLEAR_HISTORY = 'CLEAR_HISTORY'
export const clearHistory = createTypeAction(CLEAR_HISTORY)